"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESurveyState = void 0;
var ESurveyState;
(function (ESurveyState) {
    ESurveyState["INVITED"] = "I";
    ESurveyState["ERROR"] = "E";
    ESurveyState["RESPONSE"] = "R";
    ESurveyState["PLANNED"] = "P";
    ESurveyState["NONE_SENT"] = "N";
})(ESurveyState = exports.ESurveyState || (exports.ESurveyState = {}));
